import React from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Slides from '@ifeng-fe/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from 'ThreeTerminal_base/publicMethod';
import { handleAd } from '@ifeng-fe/ui_pc_ad';
import { getRecommandSlides, getRelateFeedList } from '../../../../../services/api';

let flag = 0;

class RecommendSlide extends React.PureComponent {
    static propTypes = {
        recommendData: PropTypes.array,
        base62Id: PropTypes.string,
        searchPath: PropTypes.string,
        adData: PropTypes.object,
        isFo: PropTypes.bool,
        isCloseAlgRec: PropTypes.bool,
        relatedRecommend: PropTypes.array,
        isHitBlack: PropTypes.bool,
    };

    state = {
        recommendData: this.props.recommendData,
    };

    ref = React.createRef();

    arrayPropertyUnique = (arr = [], uniId = '') => {
        const obj = {};
        const tempArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i][uniId]]) {
                tempArr.push(arr[i]);
                if (arr[i][uniId]) {
                    obj[arr[i][uniId]] = true;
                }
            }
        }

        return tempArr;
    };

    formatRelateData = (data) => {
        let result = [];

        if (!data || data.length === 0) {
            return result;
        }
        result = data.map((item) => {
            return {
                base62Id: item.base62Id,
                title: item.title,
                url: item.url,
                thumbnail:
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0] &&
                        item.thumbnails.image[0].url &&
                        formatImage(item.thumbnails.image[0].url, 180, 122)) ||
                    (item.thumbnail && formatImage(item.thumbnail, 180, 122)) ||
                    '',
            };
        });

        result = result.filter((item) => !!item.thumbnail);

        return result;
    };

    async componentDidMount() {
        const { recommendData } = this.state;
        const { base62Id, searchPath, isHitBlack, relatedRecommend, isCloseAlgRec } = this.props;
        let data = [];
        let finalDate = [];
        const relate = await getRelateFeedList(relatedRecommend);

        if (recommendData.length === 0) {
            try {
                data = await getRecommandSlides(searchPath.replace(/[, ].*/, ''), base62Id);
            } catch (e) {
                console.error(e);
            }
        } else {
            data = recommendData;
        }

        if (isHitBlack || isCloseAlgRec) {
            finalDate = this.formatRelateData(relate);
        } else {
            finalDate = [...this.formatRelateData(relate), ...data];
        }

        finalDate = this.arrayPropertyUnique(finalDate, 'base62Id');

        this.setState(
            {
                recommendData: finalDate,
            },
            async () => {
                const { infoAd5 } = this.props.adData;

                try {
                    const callbackFn = await handleAd(infoAd5);

                    callbackFn(this.ref.current, infoAd5.data);
                } catch (e) {
                    console.error(e);
                }
            },
        );
    }

    sliderTmpl = (list) => {
        flag++;

        return (
            <div className={styles.slideItem}>
                {list && list.length > 0
                    ? list.map((item, index) => (
                          <a
                              href={item.url}
                              key={index}
                              className={styles.link}
                              imgindex={index}
                              title={item.title}
                              ref={(flag === 2 || flag === 7) && index === 4 ? this.ref : ''}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title} title={item.title}>
                                  {item.title}
                              </div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    sliderTmplFo = (list) => {
        return (
            <div className={styles.slideItem}>
                {list && list.length > 0
                    ? list.map((item, index) => (
                          <a href={item.url} key={index} className={styles.link} imgindex={index} title={item.title}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title} title={item.title}>
                                  {item.title}
                              </div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    render() {
        let { recommendData } = this.state;
        const { isFo, isHitBlack } = this.props;

        if (!(recommendData instanceof Array)) {
            recommendData = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        let newList = [];

        if (recommendData.slice(0, 5).length) {
            newList = [recommendData.slice(0, 5)];
        }
        if (recommendData.slice(5, 10).length) {
            newList = [recommendData.slice(0, 5), recommendData.slice(5, 10)];
        }
        if (recommendData.slice(10).length) {
            newList = [recommendData.slice(0, 5), recommendData.slice(5, 10), recommendData.slice(10, 15)];
        }
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: newList.length > 1,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: !isFo ? this.sliderTmpl : this.sliderTmplFo,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        if (isFo) {
            return (
                <Chip id="60057" type="recommend" title="上推广" groupName="正文" content={recommendData}>
                    <div className={styles.container}>
                        <div className={styles.box}>
                            <Slides content={newList} config={config} />
                        </div>
                    </div>
                </Chip>
            );
        } else if (recommendData.length) {
            return (
                <div className={styles.container}>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            );
        }

        return '';
    }
}

export default errorBoundary(RecommendSlide);
